const images = {
  logoHeader: require('~/assets/images/logo-header.svg').default,
  logoFooter: require('~/assets/images/logo-footer.svg').default,
};
export default images;
